<h1 mat-dialog-title>
  {{ 'LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT_DIALOG_BOX_HEADING' | translate }}
</h1>
<mat-dialog-content>
  <p>
    {{ 'LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT' | translate }}
    {{ pageLabel$ | async }}?
  </p>
  <p>
    {{ 'LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT_DIALOG_BOX_CONTENT' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <div *ngIf="(isDisconnecting$ | async) !== true; else loadingIndicator">
    <button mat-button color="primary" matDialogClose>
      {{
        'LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT_DIALOG_BOX_CANCEL' | translate
      }}
    </button>
    <button mat-flat-button color="warn" (click)="Disconnect()">
      {{
        'LEAD_INTEGRATIONS.FACEBOOK.DISCONNECT_DIALOG_BOX_CONFIRM' | translate
      }}
    </button>
  </div>

  <ng-template #loadingIndicator>
    <mat-spinner diameter="36"></mat-spinner>
  </ng-template>
</mat-dialog-actions>
